import { usePollingResource } from '../hooks/usePollingResource';
import { PanelTitle } from './ui/MetricPanel';
import ResourceNotice from './ResourceNotice';
import { Link } from 'react-router-dom';

interface QualitySummary {
  calls_checked: number;
  tasks: { task: string; calls: number; ready: number; partial: number; unusable: number; review_required: number }[];
  strategy_a: { available: boolean; records: number; members: number; unknown_thesis_ids: number; uncited_reductions: number; invalid_members: number; missing_attempt_receipts: number; input_hashes_match: boolean; models: string[]; error?: string };
}
export default function LLMQualityPanel() {
  const resource = usePollingResource<QualitySummary>('/intelligence/quality', 60000);
  const data = resource.data;
  return <section className="card"><PanelTitle>저장 답변의 완결성·근거 검사</PanelTitle>
    <ResourceNotice {...resource}/>
    <p className="muted-note">최근 호출 {data?.calls_checked ?? '—'}건의 구조 검사입니다. 원래 SUCCESS·응답을 보존하며 예측 정확도를 뜻하지 않습니다.</p>
    <div className="table-wrap"><table className="intelligence-table"><thead><tr><th>작업</th><th>구조 통과</th><th>부분·사용 불가·확인 필요</th></tr></thead>
      <tbody>{data?.tasks.map(t => <tr key={t.task}><td data-label="작업"><Link to={`/management/intelligence?task=${encodeURIComponent(t.task)}`}>{t.task}</Link> · {t.calls}건</td>
        <td data-label="구조 통과">{t.ready}</td><td data-label="부분·사용 불가·확인 필요">{t.partial} · {t.unusable} · {t.review_required}</td></tr>)}</tbody></table></div>
    {data?.strategy_a && <article className="saved-report"><h4>Strategy A · 동결 원장 별도 진단</h4>
      <p className="muted-note">{data.strategy_a.models?.join(' / ')} · 동결된 기존 연구 모델. 새 Flash 검토는 별도 기록으로 보관합니다.</p>
      {data.strategy_a.available ? <p>결정 {data.strategy_a.records}개 · 모델 결과 {data.strategy_a.members}개 · 입력 해시 {data.strategy_a.input_hashes_match ? '일치' : '불일치'}<br/>
        미등록 출처 {data.strategy_a.unknown_thesis_ids}개 · 무출처 축소 {data.strategy_a.uncited_reductions}개 · 부적합 결과 {data.strategy_a.invalid_members}개 · 원래 호출 영수증 미연결 {data.strategy_a.missing_attempt_receipts}개</p>
        : <p className="research-alert">동결 원장 진단 불가 · {data.strategy_a.error}</p>}
      <p className="muted-note">진단은 기존 승수·판정·원장을 변경하지 않습니다.</p>
    </article>}
  </section>;
}
